import Product from "../../sections/Product/Product";
import "./SingleProduct.css";

function SingleProduct() {
  return (
    <main className="SingleProduct">
      <Product />
    </main>
  );
}

export default SingleProduct;
